





import { Component, Vue } from 'vue-property-decorator';

import Datepicker from '@/shared/components/datepicker/index.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    Datepicker,
    ExpansionPanel,
  },
})
export default class PartialDatepicker extends Vue {}
